// @flow

import EventEmitter from 'EventEmitter';

export default new EventEmitter();



// WEBPACK FOOTER //
// ./static/src/javascripts/lib/mediator.js